// extracted by mini-css-extract-plugin
module.exports = {"outline":"Input_outline__3uHeR","outlineOnHover":"Input_outlineOnHover__o2QwH","outlineOnFocus":"Input_outlineOnFocus__2iVZ0"};